import styled from 'styled-components';
import { Form } from '@unform/web';

export const FormView = styled(Form)`
  display: flex;
	flex-direction: column;
  width: 100%;
  // padding: 5px 0;
  margin-bottom: 5px;
	// border: 2px solid orange;

	div.input {
		display: flex;
		flex-direction: column;
		width: 100%;
		// padding-right: 10px;
		// border: 2px solid green;

		p {
			font-size: 1rem;
			font-weight: 500;
			margin: 15px 0 3px;

			span {
				font-size: 0.8rem;
				color: #455a64;
			}
		}

		span {
			font-size: 0.8rem;
			font-weight: 500;
			color: #455a64;
			text-align: end;
			width: 100%;
			padding: 5px 10px 0 0;
		}
	}

	.radio-group {
		display: flex;
		// flex-direction: column;
		width: 100%;
		padding: 5px 10px;
		// margin-right: 10px;
		border: 1px solid #d1d2dc;
		border-radius: 8px;
		
		.radio-label {
			display: flex;
			align-items: center;
			margin: 0;

			input[type='radio'] {
				margin-right: 0.2rem; // 10px;
				appearance: none;
				font: inherit;
				color: var(--azul-razio);
				width: 1.125rem; // 18px;
				height: 1.125rem; // 18px;
				border: 2px solid var(--gray-border-lw);
				border-radius: 50%;

				:checked {
					border: 5px solid var(--azul-razio);
				}
			}

			label {
				font-size: 0.9375rem; // 15px
				font-weight: 500;
				color: #455a64;
				margin-right: 100px;
			}
		};
	};

  div.form-left {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  div.form-right {
    display: flex;
    flex-direction: column;
    width: 100%;
    // padding: 10px 10px 10px 20px;
		// border: 2px solid blue;

    p {
      font-size: 1rem;
      font-weight: 500;
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      margin-bottom: 10px;
    }

    div.dados-imagem {
      display: flex;
      margin: 0 0 -10px;
      padding: 0 0 -10px;

      span {
        font-size: 0.8rem;
        font-weight: 400;
        margin: 0;
        padding: 0;
      }
      p {
        font-size: 0.8rem;
        font-weight: 600;
        margin: 0;
        padding: 0;
      }
    }
  }

	button {
    font-weight: 600;
    border-radius: 7px;
    padding: 5px 10px;
    margin: 5px 10px 0;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		// flex-direction: column-reverse;

		/* div.form-right {
			width: 100%;
			justify-content: center;
			align-items: center;
		} */

		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end; // space-between;
  align-items: center;
  background-color: #fff;
  // position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;
	// visibility: hidden;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;